import { Component, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogRef } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { EntityLineHeader } from '../../entity/entity-line-header';
import { StockLineSpecification } from '../../products/stock-line-specification';
import { StockUnitService } from '../../services/stock-unit.service';
import { StringUtils } from '../../utils/string-utils';

@Component({
  selector: 'stock-line-specs-dialog',
  templateUrl: './stock-line-specs-dialog.component.html',
  styleUrls: ['./stock-line-specs-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogActions, MatButton, MatProgressSpinner]
})
export class StockLineSpecsDialogComponent {
  private readonly stockUnitService = inject(StockUnitService);
  readonly dialogRef = inject<MatDialogRef<StockLineSpecsDialogComponent>>(MatDialogRef);
  private readonly data = inject(MAT_DIALOG_DATA);

  public readonly entityLine: EntityLineHeader;
  public readonly specifications = signal<StockLineSpecification[]>([]);
  public readonly isBusy = signal<boolean>(true);
  public readonly errorMessage = signal<string>(undefined!);

  constructor() {
    this.entityLine = this.data.line as EntityLineHeader;
    this.stockUnitService.getLineSpecifications(this.entityLine.key.entityId, this.entityLine.key.entityRevision, this.entityLine.lineId).subscribe({
      next: (result: StockLineSpecification[]) => {
        this.specifications.set(result || []);
        this.isBusy.set(false);
      },
      error: (error: any) => {
        this.errorMessage.set(StringUtils.getErrorMessage(error) || 'The specifications for this unit could not be loaded.');
        this.isBusy.set(false);
      },
    });
  }

  public close(): void {
    this.dialogRef.close(null);
  }

}
